import PropTypes from 'prop-types';
import React from 'react';

const getInitials = str => {
  const words = (str || '').trim().split(/\s+/).filter(Boolean);

  if (!words.length) {
    return '';
  }

  if (words.length === 1) {
    return words[0][0].toUpperCase();
  }

  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
};

const SelectableUser = ({ user, updateMentionedUsers, isMentioned }) => {
  return (
    <div
      className='single-user__row'
      onClick={() => updateMentionedUsers(user.username, isMentioned)}
    >
      <div className='comment__avatar'>
        <span>{getInitials(user?.name)}</span>
      </div>
      <div className='name-container'>
        <p>
          {user.name} (<small>{user.username}</small>)
        </p>
      </div>
      <div className='selector__container'>
        <input type='checkbox' checked={isMentioned} />
      </div>
    </div>
  );
};

SelectableUser.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    username: PropTypes.string, // used for email
    uri: PropTypes.string,
  }).isRequired,
  updateMentionedUsers: PropTypes.func.isRequired,
  isMentioned: PropTypes.bool.isRequired,
};

export default SelectableUser;
